module.exports = __webpack_public_path__ + "img/background065.0d574036.jpg";